var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTreeNewVerde2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 228,
    height: 314,
    viewBox: "0 0 228 314",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M122.672 81.526C116.969 78.1823 110.604 78.1823 104.906 81.526L63.0365 105.604C57.3385 108.948 54.3281 114.297 54.3281 120.995V169.141C54.3281 175.833 57.3385 181.182 63.0365 184.531L104.906 208.604C110.604 211.953 116.969 211.953 122.672 208.604L164.536 184.531C170.24 181.182 173.245 175.833 173.245 169.141V120.995C173.245 114.297 170.24 108.948 164.536 105.604L122.672 81.526ZM170.24 95.9063C179.276 101.255 184.635 110.281 184.635 120.995V169.141C184.635 179.854 179.276 188.88 170.24 194.229L128.359 218.302C119.318 223.651 108.255 223.651 99.2188 218.302L57.3385 194.229C48.2969 188.88 42.9375 179.854 42.9375 169.141V120.995C42.9375 110.281 48.2969 101.255 57.3385 95.9063L99.2188 71.8281C108.255 66.4687 119.318 66.4687 128.359 71.8281L170.24 95.9063Z",
    fill: "#3BAE5B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M113.672 150.453L113.672 272.245Z",
    fill: "#3BAE5B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M113.672 150.453L113.672 272.245",
    stroke: "#3BAE5B",
    strokeWidth: 12.2402
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M113.714 181.396L155.589 133.135Z",
    fill: "#3BAE5B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M113.714 181.396L155.589 133.135",
    stroke: "#3BAE5B",
    strokeWidth: 12.251
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M87.5834 170.214L113.708 201.734Z",
    fill: "#3BAE5B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M87.5834 170.214L113.708 201.734",
    stroke: "#3BAE5B",
    strokeWidth: 12.2385
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M122.672 81.526C116.969 78.1823 110.604 78.1823 104.906 81.526L63.0365 105.604C57.3385 108.948 54.3281 114.297 54.3281 120.995V169.141C54.3281 175.833 57.3385 181.182 63.0365 184.531L104.906 208.604C110.604 211.953 116.969 211.953 122.672 208.604L164.536 184.531C170.24 181.182 173.245 175.833 173.245 169.141V120.995C173.245 114.297 170.24 108.948 164.536 105.604L122.672 81.526ZM170.24 95.9063C179.276 101.255 184.635 110.281 184.635 120.995V169.141C184.635 179.854 179.276 188.88 170.24 194.229L128.359 218.302C119.318 223.651 108.255 223.651 99.2188 218.302L57.3385 194.229C48.2969 188.88 42.9375 179.854 42.9375 169.141V120.995C42.9375 110.281 48.2969 101.255 57.3385 95.9063L99.2188 71.8281C108.255 66.4687 119.318 66.4687 128.359 71.8281L170.24 95.9063Z",
    fill: "#3BAE5B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M113.672 150.453L113.672 272.245Z",
    fill: "#3BAE5B"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M113.672 150.453L113.672 272.245",
    stroke: "#3BAE5B",
    strokeWidth: 12.2402
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M113.714 181.396L155.589 133.135Z",
    fill: "#3BAE5B"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M113.714 181.396L155.589 133.135",
    stroke: "#3BAE5B",
    strokeWidth: 12.251
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M87.5834 170.214L113.708 201.734Z",
    fill: "#3BAE5B"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M87.5834 170.214L113.708 201.734",
    stroke: "#3BAE5B",
    strokeWidth: 12.2385
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M122.672 81.526C116.969 78.1823 110.604 78.1823 104.906 81.526L63.0365 105.604C57.3385 108.948 54.3281 114.297 54.3281 120.995V169.141C54.3281 175.833 57.3385 181.182 63.0365 184.531L104.906 208.604C110.604 211.953 116.969 211.953 122.672 208.604L164.536 184.531C170.24 181.182 173.245 175.833 173.245 169.141V120.995C173.245 114.297 170.24 108.948 164.536 105.604L122.672 81.526ZM170.24 95.9063C179.276 101.255 184.635 110.281 184.635 120.995V169.141C184.635 179.854 179.276 188.88 170.24 194.229L128.359 218.302C119.318 223.651 108.255 223.651 99.2188 218.302L57.3385 194.229C48.2969 188.88 42.9375 179.854 42.9375 169.141V120.995C42.9375 110.281 48.2969 101.255 57.3385 95.9063L99.2188 71.8281C108.255 66.4687 119.318 66.4687 128.359 71.8281L170.24 95.9063Z",
    fill: "#3BAE5B"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M113.672 150.453L113.672 272.245Z",
    fill: "#3BAE5B"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M113.672 150.453L113.672 272.245",
    stroke: "#3BAE5B",
    strokeWidth: 12.2402
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M113.714 181.396L155.589 133.135Z",
    fill: "#3BAE5B"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M113.714 181.396L155.589 133.135",
    stroke: "#3BAE5B",
    strokeWidth: 12.251
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M87.5834 170.214L113.708 201.734Z",
    fill: "#3BAE5B"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M87.5834 170.214L113.708 201.734",
    stroke: "#3BAE5B",
    strokeWidth: 12.2385
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTreeNewVerde2);
export default __webpack_public_path__ + "static/media/tree-new-verde-2.8c71ca5a44dab4cb7a04671d63131382.svg";
export { ForwardRef as ReactComponent };